(function () {
  const config = window.LaCometCatalogMode;

  if (!config || !config.isB2BCustomer) {
    return;
  }

  const modeStorageKey = config.modeStorageKey || "lacometCatalogMode";
  const compactStorageKey = config.compactStorageKey || "lacometCatalogCompactView";
  const modeCookieKey = config.modeCookieKey || "lacomet_catalog_mode";
  const compactCookieKey = config.compactCookieKey || "lacomet_catalog_compact";
  const onDemandUrlKey = config.onDemandUrlStorageKey || "lacometCatalogOnDemandUrl";
  const prontoUrlKey = config.prontoUrlStorageKey || "lacometCatalogProntoUrl";
  const defaultMode = config.defaultMode || "pronto";

  function readCookie(name) {
    const prefix = `${name}=`;
    const cookie = document.cookie
      .split("; ")
      .find((part) => part.indexOf(prefix) === 0);

    return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : "";
  }

  function writeCookie(name, value) {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=31536000; SameSite=Lax`;
  }

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key) || "";
    } catch (error) {
      return "";
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function getStoredMode() {
    return readStorage(modeStorageKey) || readCookie(modeCookieKey) || defaultMode;
  }

  function getStoredCompactView() {
    return (readStorage(compactStorageKey) || readCookie(compactCookieKey)) === "true";
  }

  function getEntryUrl(mode) {
    const key = mode === "on-demand" ? onDemandUrlKey : prontoUrlKey;
    return readStorage(key);
  }

  function applyState(mode, compactView) {
    document.documentElement.dataset.catalogMode = mode;
    document.documentElement.dataset.catalogCompactView = compactView ? "true" : "false";
    document.body.dataset.catalogMode = mode;
    document.body.dataset.catalogCompactView = compactView ? "true" : "false";
  }

  function persistState(mode, compactView, entryUrl) {
    writeStorage(modeStorageKey, mode);
    writeStorage(compactStorageKey, compactView ? "true" : "false");
    writeCookie(modeCookieKey, mode);
    writeCookie(compactCookieKey, compactView ? "true" : "false");

    if (entryUrl) {
      writeStorage(mode === "on-demand" ? onDemandUrlKey : prontoUrlKey, entryUrl);
    }
  }

  function hideEmptyContainers(root) {
    root.querySelectorAll(".predictive-search__products").forEach((container) => {
      const visibleItems = Array.from(container.children).filter((item) => !item.hidden);

      if (visibleItems.length === 0) {
        container.setAttribute("hidden", "hidden");
      } else {
        container.removeAttribute("hidden");
      }
    });
  }

  function filterCatalogProducts(root) {
    const mode = document.documentElement.dataset.catalogMode || defaultMode;

    root.querySelectorAll("[data-catalog-product-type]").forEach((element) => {
      const productType = element.getAttribute("data-catalog-product-type");
      const shouldHide = mode === "on-demand" ? productType !== "on-demand" : productType === "on-demand";

      if (shouldHide) {
        element.hidden = true;
        element.classList.add("catalog-mode-hidden");
      } else {
        element.hidden = false;
        element.classList.remove("catalog-mode-hidden");
      }
    });

    hideEmptyContainers(root);
  }

  function syncEntrySection() {
    const entrySection = document.querySelector('[data-catalog-entry-mode="on-demand"], [data-catalog-entry-mode="pronto"]');

    if (!entrySection) {
      return;
    }

    const mode = entrySection.dataset.catalogEntryMode;
    const compactView = entrySection.dataset.catalogCompactView === "true";
    const entryUrl = entrySection.dataset.catalogEntryUrl || window.location.pathname;

    persistState(mode, compactView, entryUrl);
    applyState(mode, compactView);
  }

  function enforceProductPageMode() {
    if (document.body.dataset.pageType !== "product") {
      return;
    }

    const mode = document.documentElement.dataset.catalogMode || defaultMode;
    const productType = document.body.dataset.productType;

    if (!productType) {
      return;
    }

    const isMismatch = mode === "on-demand" ? productType !== "on-demand" : productType === "on-demand";

    if (!isMismatch) {
      return;
    }

    const targetUrl = getEntryUrl(mode);

    if (targetUrl && targetUrl !== window.location.pathname) {
      window.location.replace(targetUrl);
    }
  }

  function bootstrap() {
    applyState(getStoredMode(), getStoredCompactView());
    syncEntrySection();
    filterCatalogProducts(document);
    enforceProductPageMode();

    const observer = new MutationObserver((mutations) => {
      const hasRelevantChange = mutations.some((mutation) => mutation.addedNodes.length > 0);

      if (hasRelevantChange) {
        filterCatalogProducts(document);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
  } else {
    bootstrap();
  }
})();